import { avatarStyle } from '$synapse/core';
import { ExamStatus } from '$synapse/models';
import { Component, input } from '@angular/core';
import { SHARED_IMPORTS } from '../../shared-imports';

@Component({
  selector: 'syn-status-avatar',
  templateUrl: './status-avatar.component.html',
  styleUrls: ['./status-avatar.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class StatusAvatarComponent {
  readonly examStatus = input<ExamStatus>(undefined);
  readonly border = input<boolean>(false);
  readonly volume = input<boolean>(true);

  readonly avatarStyle = avatarStyle;
}
